import { useRef, useState } from "react";
import { Button, Form, Input } from "antd";
import { FloppyDiskBack } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { t, useStoreLanguage } from "../../../features/store-language/i18n.ts";
import AppFeedback from "../../shared/AppFeedback.tsx";
import { changeAgencyPassword } from "../Auth/agencyIdentityService.ts";
import { agencyPasswordRules } from "../Auth/agencyPasswordPolicy.ts";

export default function AgencyPasswordForm() {
  useStoreLanguage();
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);
  const inFlight = useRef(false);

  async function submit(values: { currentPassword: string; newPassword: string }) {
    if (inFlight.current) return;
    inFlight.current = true;
    setPending(true);
    try {
      await changeAgencyPassword(values.currentPassword, values.newPassword);
      void AppFeedback.success({ title: t("رمز تغییر کرد؛ با رمز جدید دوباره وارد شوید.") });
      navigate("/login", { replace: true });
    } catch (error) {
      AppFeedback.httpError(error);
    } finally {
      inFlight.current = false;
      setPending(false);
    }
  }

  return (
    <div className="agency-password-form">
      <Form
        disabled={pending}
        layout="vertical"
        onFinish={submit}
      >
        <Form.Item
          label={t("رمز فعلی")}
          name="currentPassword"
          rules={[{ required: true, message: t("رمز فعلی را وارد کنید.") }]}
        >
          <Input.Password autoComplete="current-password" />
        </Form.Item>
        <Form.Item
          label={t("رمز جدید")}
          name="newPassword"
          extra={t("حداقل ۱۵ حرف؛ از تکرار یک کاراکتر یا واژه استفاده نکنید.")}
          rules={agencyPasswordRules()}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Button
          disabled={pending}
          htmlType="submit"
          icon={<FloppyDiskBack size={17} />}
          loading={pending}
          type="primary"
        >
          {t("تغییر رمز و خروج از نشست‌ها")}
        </Button>
      </Form>
    </div>
  );
}
